import React, { useState, useEffect } from 'react';
import '../../styles/15-activity.css';

const API_BASE = process.env.REACT_APP_API_URL || '/detsa/api';

const AdminActivity = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({});
  const [pagination, setPagination] = useState({});
  
  // Filtreleme state'leri
  const [filters, setFilters] = useState({
    page: 1,
    limit: 50,
    action_type: '',
    user_email: '',
    related_table: '',
    start_date: '',
    end_date: ''
  });
  
  const [activityTypes, setActivityTypes] = useState([]);
  const [relatedTables, setRelatedTables] = useState([]);

  useEffect(() => {
    fetchActivities();
    fetchStats();
    fetchActivityTypes();
    fetchRelatedTables();
  }, [filters]);

  const fetchActivities = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });

      const response = await fetch(`${API_BASE}/admin/activities?${queryParams}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (response.ok) {
        setActivities(data.activities);
        setPagination(data.pagination);
      } else {
        console.error('Aktiviteler alınamadı:', data.error);
      }
    } catch (error) {
      console.error('Aktiviteler alınamadı:', error);
    }
    setLoading(false);
  };

  const fetchStats = async () => {
    try {
      const response = await fetch(`${API_BASE}/admin/activity-stats`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (response.ok) {
        setStats(data.stats);
      }
    } catch (error) {
      console.error('İstatistikler alınamadı:', error);
    }
  };

  const fetchActivityTypes = async () => {
    try {
      const response = await fetch(`${API_BASE}/admin/activity-types`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (response.ok) {
        setActivityTypes(data.activity_types);
      }
    } catch (error) {
      console.error('Aktivite türleri alınamadı:', error);
    }
  };

  const fetchRelatedTables = async () => {
    try {
      const response = await fetch(`${API_BASE}/admin/related-tables`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (response.ok) {
        setRelatedTables(data.related_tables);
      }
    } catch (error) {
      console.error('İlişkili tablolar alınamadı:', error);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      page: 1, // Filtre değiştiğinde sayfa 1'e dön
      [key]: value
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({
      ...prev,
      page: newPage
    }));
  };

  const clearFilters = () => {
    setFilters({
      page: 1,
      limit: 50,
      action_type: '',
      user_email: '',
      related_table: '',
      start_date: '',
      end_date: ''
    });
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('tr-TR');
  };

  const getActionTypeIcon = (actionType) => {
    const icons = {
      user_created: '👤➕',
      user_updated: '👤✏️',
      user_deleted: '👤🗑️',
      inventory_created: '📦➕',
      inventory_updated: '📦✏️',
      inventory_deleted: '📦🗑️',
      inventory_assigned: '📦👤',
      inventory_unassigned: '📦❌',
      ticket_created: '🎫➕',
      ticket_updated: '🎫✏️',
      login: '🔑',
      logout: '🚪'
    };
    return icons[actionType] || '📝';
  };

  const getActionTypeLabel = (actionType) => {
    const labels = {
      user_created: 'Kullanıcı Eklendi',
      user_updated: 'Kullanıcı Güncellendi',
      user_deleted: 'Kullanıcı Silindi',
      inventory_created: 'Envanter Eklendi',
      inventory_updated: 'Envanter Güncellendi',
      inventory_deleted: 'Envanter Silindi',
      inventory_assigned: 'Envanter Atandı',
      inventory_unassigned: 'Envanter Geri Alındı',
      ticket_created: 'Talep Oluşturuldu',
      ticket_updated: 'Talep Güncellendi',
      login: 'Giriş Yapıldı',
      logout: 'Çıkış Yapıldı'
    };
    return labels[actionType] || actionType;
  };

  return (
    <div className="admin-activity-container">
      {/* Header */}
      <div className="admin-activity-header">
        <h3>Sistem Hareketleri</h3>
        <div className="admin-activity-stats-mini">
          <div className="admin-activity-stat-item">
            <span className="admin-activity-stat-label">Toplam</span>
            <span className="admin-activity-stat-value">{stats.total || 0}</span>
          </div>
          <div className="admin-activity-stat-item">
            <span className="admin-activity-stat-label">Bugün</span>
            <span className="admin-activity-stat-value">{stats.today || 0}</span>
          </div>
          <div className="admin-activity-stat-item">
            <span className="admin-activity-stat-label">Bu Hafta</span>
            <span className="admin-activity-stat-value">{stats.this_week || 0}</span>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="admin-activity-filters">
        <div className="admin-activity-filter-row">
          <div className="admin-activity-filter-group">
            <div className="admin-activity-filter-grid">
              <div className="admin-activity-filter-grid-row">
                <input
                  type="text"
                  placeholder="Kullanıcı email ara..."
                  value={filters.user_email}
                  onChange={(e) => handleFilterChange('user_email', e.target.value)}
                  className="admin-activity-search-input"
                />
                
                <select
                  value={filters.action_type}
                  onChange={(e) => handleFilterChange('action_type', e.target.value)}
                  className="admin-activity-filter-select"
                >
                  <option value="">Tüm İşlem Türleri</option>
                  {activityTypes.map(type => (
                    <option key={type.action_type} value={type.action_type}>
                      {getActionTypeLabel(type.action_type)} ({type.count})
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="admin-activity-filter-grid-row">
                <select
                  value={filters.related_table}
                  onChange={(e) => handleFilterChange('related_table', e.target.value)}
                  className="admin-activity-filter-select"
                >
                  <option value="">Tüm Tablolar</option>
                  {relatedTables.map(table => (
                    <option key={table.related_table} value={table.related_table}>
                      {table.related_table} ({table.count})
                    </option>
                  ))}
                </select>

                <select
                  value={filters.limit}
                  onChange={(e) => handleFilterChange('limit', e.target.value)}
                  className="admin-activity-filter-select"
                >
                  <option value="25">25 kayıt</option>
                  <option value="50">50 kayıt</option>
                  <option value="100">100 kayıt</option>
                  <option value="200">200 kayıt</option>
                </select>
              </div>

              <div className="admin-activity-filter-grid-row">
                <input
                  type="date"
                  value={filters.start_date}
                  onChange={(e) => handleFilterChange('start_date', e.target.value)}
                  className="admin-activity-date-input"
                  placeholder="Başlangıç tarihi"
                />
                
                <input
                  type="date"
                  value={filters.end_date}
                  onChange={(e) => handleFilterChange('end_date', e.target.value)}
                  className="admin-activity-date-input"
                  placeholder="Bitiş tarihi"
                />
              </div>
            </div>
          </div>
          
          <div className="admin-activity-filter-actions">
            <button onClick={clearFilters} className="admin-activity-btn-clear-filters">
              🔄 Temizle
            </button>
            <span className="admin-activity-count">
              {pagination.total_records || 0} kayıt
            </span>
          </div>
        </div>
      </div>

      {/* Activities List */}
      {loading ? (
        <div className="admin-activity-loading">Hareketler yükleniyor...</div>
      ) : activities.length === 0 ? (
        <div className="admin-activity-no-data">
          Herhangi bir hareket bulunamadı.
        </div>
      ) : (
        <>
          <div className="admin-activity-list">
            {activities.map((activity) => (
              <div key={activity.id} className="admin-activity-card">
                <div className="admin-activity-icon">
                  {getActionTypeIcon(activity.action_type)}
                </div>
                
                <div className="admin-activity-content">
                  <div className="admin-activity-header-item">
                    <h4>{getActionTypeLabel(activity.action_type)}</h4>
                    <span className="admin-activity-time">
                      {formatDate(activity.timestamp)}
                    </span>
                  </div>
                  
                  <div className="admin-activity-details">
                    <p className="admin-activity-description">
                      {activity.description}
                    </p>
                    
                    <div className="admin-activity-meta">
                      <div className="admin-activity-user">
                        👤 {activity.user_full_name}
                      </div>
                      
                      {activity.related_table && (
                        <div className="admin-activity-table">
                          📋 {activity.related_table}
                        </div>
                      )}
                      
                      {activity.related_id && (
                        <div className="admin-activity-id">
                          🆔 ID: {activity.related_id}
                        </div>
                      )}
                    </div>
                    
                    {(activity.old_value || activity.new_value) && (
                      <div className="admin-activity-changes">
                        {activity.old_value && (
                          <div className="admin-activity-change-old">
                            <strong>Eski değer:</strong> {activity.old_value}
                          </div>
                        )}
                        {activity.new_value && (
                          <div className="admin-activity-change-new">
                            <strong>Yeni değer:</strong> {activity.new_value}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {pagination.total_pages > 1 && (
            <div className="admin-activity-pagination">
              <button
                onClick={() => handlePageChange(pagination.current_page - 1)}
                disabled={pagination.current_page <= 1}
                className="admin-activity-btn-pagination"
              >
                ⬅️ Önceki
              </button>
              
              <span className="admin-activity-pagination-info">
                Sayfa {pagination.current_page} / {pagination.total_pages}
              </span>
              
              <button
                onClick={() => handlePageChange(pagination.current_page + 1)}
                disabled={pagination.current_page >= pagination.total_pages}
                className="admin-activity-btn-pagination"
              >
                Sonraki ➡️
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AdminActivity;